import {CoreDI} from '@gongxigames/framework/core/configs';
import {inject} from '@gongxigames/framework/core/installer';
import {GameConfig} from '@gongxigames/framework/slot/types';
import {UILayout} from '@gongxigames/framework/slotV2/types';
import {UiServiceV2} from '@gongxigames/framework/slotV2/baseClasses/uiServiceV2/UIServiceV2';
import {UI_LAYOUTS} from './uiLayouts';
import {uiLayoutsStore} from './uiLayoutsStore';

export class UIPresetConfigProviderService extends UiServiceV2 {
    public static NAME: symbol = CoreDI.UIPresetConfigProviderService;

    @inject(CoreDI.GameConfig)
    private readonly _gameConfig!: GameConfig;

    private _layout?: UILayout;

    public onInit(): void {
        uiLayoutsStore.ui_layout.value = this.getUIZoneConfig();
    }

    public getUIZoneConfig(): UILayout {
        if (this._layout) {
            return this._layout;
        }

        const {
            gameProvider,
            uiLayoutName = 'default'
        } = this._gameConfig;

        this._layout = UI_LAYOUTS.find(item => item.gameProvider === gameProvider && item.name === uiLayoutName);

        if (!this._layout) {
            throw new Error('Cant find UI layout...');
        }

        return this._layout;
    }
}
